import { kcal } from '../lib/format';

interface RingProps {
  eaten: number;
  /** Null when there's no calorie target (counting without goals): the ring shows what was eaten, with no budget. */
  goal: number | null;
  size?: number;
  stroke?: number;
}

/** Calorie budget ring: the arc fills as you eat; the center shows what's left. Without a target, just what you ate. */
export function Ring({ eaten, goal, size = 148, stroke = 14 }: RingProps) {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const budget = goal !== null && goal > 0;
  const pct = budget ? Math.min(1, eaten / goal) : 0;
  const left = budget ? goal - eaten : 0;
  const over = left < 0;
  const label = budget ? `${kcal(Math.abs(left))} calories ${over ? 'over' : 'left'} of ${kcal(goal)}` : `${kcal(eaten)} calories eaten, no daily target`;
  return (
    <div className={`ring ${over ? 'is-over' : ''}`} style={{ width: size, height: size }} role="img" aria-label={label}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} aria-hidden="true">
        <circle className="ring__track" cx={size / 2} cy={size / 2} r={r} fill="none" strokeWidth={stroke} />
        {budget && (
          <circle
            className="ring__fill"
            cx={size / 2}
            cy={size / 2}
            r={r}
            fill="none"
            strokeWidth={stroke}
            strokeLinecap="round"
            strokeDasharray={c}
            strokeDashoffset={c * (1 - pct)}
            transform={`rotate(-90 ${size / 2} ${size / 2})`}
          />
        )}
      </svg>
      <div className="ring__center">
        <div className="ring__big num">{kcal(budget ? Math.abs(left) : eaten)}</div>
        <div className="ring__label">{budget ? (over ? 'kcal over' : 'kcal left') : 'kcal eaten'}</div>
      </div>
    </div>
  );
}
